import * as React from 'react';
import Modal from "react-responsive-modal";
import Input from '../../../../../common/Input/Input'
import './createUserModalStyles.css'
import InputUtils, {Type} from "../../../../../../InputUtils";
import Utils from "../../../../../../Utils";

interface Props {
    createUser(user): void,

    editUser(user): any,

    restoreEventListener(): void,

    hideModal(): void,

    tenant: any
    roles: any
    showModal: boolean,
    selectedUser: any,
}

interface State {
    validateForm: boolean;
    form: any,
}

class CrateUserModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            validateForm: false,
            form: {
                firstName: {
                    value: '',
                    valid: true,
                    errorMsg: 'First name cannot be empty'
                },
                lastName: {
                    value: '',
                    valid: true,
                    errorMsg: 'Last name cannot be empty',
                },
                userName: {
                    value: '',
                    valid: true,
                    errorMsg: 'Username name cannot be empty',
                },
                password: {
                    value: '',
                    valid: true,
                    errorMsg: 'Password length must be at least 4 characters',
                },
                confirmPass: {
                    value: '',
                    valid: true,
                    errorMsg: 'Passwords do not match',
                },
                email: {
                    value: '',
                    valid: true,
                    errorMsg: 'Invalid email address',
                },
                roles: {
                    value: [],
                    valid: true,
                    errorMsg: '',
                    options: [],
                },
                systemAdministrator: {
                    value: 0,
                    valid: true
                },
            }
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.props.showModal && this.props.roles !== prevProps.roles) {
            this.loadUserToForm();
            document.addEventListener('keydown', this.keydownModalHandler);
        }
        if (this.props.showModal !== prevProps.showModal && !this.props.showModal) {
            document.removeEventListener('keydown', this.keydownModalHandler);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownModalHandler);
    }

    keydownModalHandler = (e) => {
        if (e.keyCode === 13 && !e.target.id.includes('select')) {
            Utils.$('#btn-save').click();
        }
    }

    loadUserToForm = () => {
        let formCopy = JSON.parse(JSON.stringify(this.state.form));
        this.loadDropDownOptions(formCopy);
        if (this.props.selectedUser) {
            const selectedUser = JSON.parse(JSON.stringify(this.props.selectedUser));
            const keys = Object.keys(selectedUser);

            keys.forEach(key => {
                if (formCopy.hasOwnProperty(key) && (key === 'firstName' || key === 'lastName' || key === 'email' || key === 'roles' || key === 'systemAdministrator')) {
                    if (key.toLowerCase() === 'roles') {
                        formCopy = {
                            ...formCopy,
                            [key]: {
                                ...formCopy[key],
                                value: this.getLoadedRole(selectedUser[key])
                            }
                        }
                    } else if (key === 'systemAdministrator') {
                        formCopy = {
                            ...formCopy,
                            [key]: {
                                ...formCopy[key],
                                value: selectedUser[key] === true ? 1 : 0
                            }
                        }
                    } else {
                        formCopy = {
                            ...formCopy,
                            [key]: {
                                ...formCopy[key],
                                value: selectedUser[key] ? selectedUser[key] : ''
                            }
                        }
                    }
                }
            })
        }
        this.setState({
            form: formCopy
        })
    }

    loadDropDownOptions = (form?: any) => {
        if (this.props.roles.length > 0) {
            if (form) {
                form.roles.options = this.props.roles;
            } else {
                let formCopy = JSON.parse(JSON.stringify(this.state.form));
                formCopy.apiEndpoints.options = this.props.roles;
                this.setState({
                    form: formCopy
                })
            }
        }
    }

    getLoadedRole = (values: any) => {
        let found = [];
        values.forEach(val => {
            let searched = this.props.roles.find(item => {
                return item.label.toLowerCase() === val.toLowerCase()
            })
            if (searched) {
                found.push(searched);
            }
        })
        return found;
    }

    open = () => {
        this.resetForm();
        this.setState({
            validateForm: false,
        });
    };

    resetForm = () => {
        this.setState({
            form: InputUtils.resetForm(this.state.form)
        })
    }

    close = () => {
        this.resetForm();
        this.props.hideModal();
        this.props.restoreEventListener()
    };

    onChange = (event, id, inputType) => {
        let eventValue;
        if (inputType === 'select') {
            eventValue = event ? event : [];
        } else if (inputType === 'inputSwitch') {
            if (event.target.value === 'true') {
                eventValue = 0;
            } else {
                eventValue = 1;
            }
        } else {
            eventValue = event.target.value;
        }

        this.setState({
            form: {
                ...this.state.form,
                [id]: {
                    ...this.state.form[id],
                    value: eventValue,
                    valid: true
                }
            }
        })
    }

    createUserHandler = () => {
        if (this.checkFormValidity()) {
            let dto = {};
            if (this.props.selectedUser) {
                const removedRoles = [];
                const addedRoles = [];
                this.props.selectedUser.roles.forEach(item => {
                    const found = this.state.form.roles.value.find(role => role.label === item)
                    if (!found) {
                        const role = this.state.form.roles.options.find(role => role.label === item)
                        removedRoles.push(role.id);
                    }
                })

                this.state.form.roles.value.forEach(item => {
                    const found = this.props.selectedUser.roles.find(role => role === item.label)
                    if (!found) {
                        addedRoles.push(item.id);
                    }
                });

                dto = {
                    email: this.state.form.email.value,
                    firstName: this.state.form.firstName.value,
                    lastName: this.state.form.lastName.value,
                    addedRoles: addedRoles,
                    removedRoles: removedRoles,
                    systemAdministrator: this.state.form.systemAdministrator.value === 1
                }
                this.props.editUser(dto)
                    .then((response) => {
                        // if response === undefined there are no changes.
                        if (response) {
                            setTimeout(() => {
                                this.resetForm();
                                this.props.restoreEventListener();
                            }, 200)
                        }
                    })
            } else {
                dto = {
                    email: this.state.form.email.value,
                    firstName: this.state.form.firstName.value,
                    lastName: this.state.form.lastName.value,
                    password: this.state.form.password.value,
                    username: this.state.form.userName.value,
                    addedRoles: this.state.form.roles.value.map(role => {
                        return role.id
                    }),
                }
                this.props.createUser(dto)
                setTimeout(() => {
                    this.resetForm();
                    this.props.restoreEventListener();
                }, 200)
            }
        }
    }

    checkFormValidity = (): boolean => {
        const keys = Object.keys(this.state.form);
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            switch (key) {
                case 'firstName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'lastName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'userName':
                    if (!this.props.selectedUser && formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'email':
                    const str = formCopy[key].value;
                    if (!InputUtils.EMAIL_REGEX.test(str)) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'password':
                    const pass = formCopy[key].value;
                    if (!this.props.selectedUser && !InputUtils.PASSWORD_REGEX.test(pass)) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'confirmPass':
                    if (!this.props.selectedUser && formCopy[key].value !== formCopy[keys[index - 1]].value) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
            }
        })

        this.setState({
            form: formCopy
        })

        return formIsValid;
    }

    render() {
        return (
            <Modal
                open={this.props.showModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 750,
                        padding: 0,
                        maxWidth: 750,
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-user-container'} className='col-lg-12 compare-changes'>
                            <header className={'create-user-modal-header'}>
                                <h2>{this.props.selectedUser ? 'Edit User' : 'Create User'}</h2>
                            </header>
                            <div
                                className={this.props.selectedUser ? 'edit-user-modal-container' : 'create-user-modal-container'}>
                                <div className={'createUserForm'}>
                                    <Input id={'firstName'}
                                           value={this.state.form.firstName.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'firstName', 'input')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={this.state.form.firstName.valid}
                                           errorMsg={this.state.form.firstName.errorMsg}
                                           wrapperClass={'half-width-float-left'}
                                           label={'First Name'}
                                           elementConfig={{
                                               placeholder: 'First Name',
                                               tabIndex: 1
                                           }}
                                    />
                                    <Input id={'lastName'}
                                           value={this.state.form.lastName.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'lastName', 'input')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={this.state.form.lastName.valid}
                                           errorMsg={this.state.form.lastName.errorMsg}
                                           wrapperClass={'half-width'}
                                           label={'Last Name'}
                                           elementConfig={{
                                               placeholder: 'Last Name',
                                               tabIndex: 2
                                           }}
                                    />
                                    {!this.props.selectedUser ? <Input id={'userName'}
                                                                       value={this.state.form.userName.value}
                                                                       elementType={Type.INPUT}
                                                                       changed={(event) => this.onChange(event, 'userName', 'input')}
                                                                       classNameProp={'input-full-width margin-input-for-label'}
                                                                       required={true}
                                                                       valid={this.state.form.userName.valid}
                                                                       errorMsg={this.state.form.userName.errorMsg}
                                                                       wrapperClass={'half-width-float-left'}
                                                                       label={'Username'}
                                                                       elementConfig={{
                                                                           placeholder: 'Username',
                                                                           tabIndex: 3
                                                                       }}
                                    /> : null}
                                    <Input id={'email'}
                                           value={this.state.form.email.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'email', 'input')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={this.state.form.email.valid}
                                           errorMsg={this.state.form.email.errorMsg}
                                           wrapperClass={this.props.selectedUser ? '' : 'half-width'}
                                           label={'Email'}
                                           elementConfig={{
                                               placeholder: 'Email',
                                               tabIndex: 4
                                           }}
                                    />
                                    <Input id={'select'}
                                           value={this.state.form.roles.value}
                                           required={true}
                                           elementType={Type.SELECT}
                                           changed={(event) => this.onChange(event, 'roles', 'select')}
                                           classNameProp={'input-full-width margin-input-for-label custom-select-menu-initial-position'}
                                           errorMsg={this.state.form.roles.errorMsg}
                                           valid={this.state.form.roles.valid}
                                           selectInitialPosition={true}
                                           label={'Roles'}
                                           elementConfig={{
                                               placeholder: 'Select Roles',
                                               isMulti: true,
                                               closeMenuOnSelect: false,
                                               tabIndex: 5,
                                               options: this.state.form.roles.options
                                           }}
                                    />
                                    {!this.props.selectedUser ? <Input id={'password'}
                                                                       value={this.state.form.password.value}
                                                                       required={true}
                                                                       elementType={Type.INPUT}
                                                                       changed={(event) => this.onChange(event, 'password', 'input')}
                                                                       classNameProp={'input-full-width margin-input-for-label'}
                                                                       valid={this.state.form.password.valid}
                                                                       errorMsg={this.state.form.password.errorMsg}
                                                                       wrapperClass={'half-width-float-left'}
                                                                       label={'Password'}
                                                                       elementConfig={{
                                                                           placeholder: 'Password',
                                                                           tabIndex: 6,
                                                                           type: 'password',
                                                                           autocomplete:"new-password"
                                                                       }}
                                    /> : null}
                                    {!this.props.selectedUser ? <Input id={'confirmPass'}
                                                                       value={this.state.form.confirmPass.value}
                                                                       required={true}
                                                                       elementType={Type.INPUT}
                                                                       changed={(event) => this.onChange(event, 'confirmPass', 'input')}
                                                                       classNameProp={'input-full-width margin-input-for-label'}
                                                                       errorMsg={this.state.form.confirmPass.errorMsg}
                                                                       label={'Confirm Password'}
                                                                       valid={this.state.form.confirmPass.valid}
                                                                       wrapperClass={'half-width'}
                                                                       elementConfig={{
                                                                           placeholder: 'Confirm Password',
                                                                           tabIndex: 7,
                                                                           type: 'password'
                                                                       }}
                                    /> : null}
                                    {this.props.selectedUser ? <Input id={'systemAdministrator'}
                                           value={this.state.form.systemAdministrator.value === 1 ? "true" : "false"}
                                           required={false}
                                           elementType={Type.INPUT_SWITCH}
                                           changed={(event) => this.onChange(event, 'systemAdministrator', 'inputSwitch')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           labelExtraClass={'fullWidthLabel'}
                                           label={'System Administrator'}
                                           wrapperClass={this.state.form.systemAdministrator.value === 1 ? 'half-width-float-left' : ''}
                                           elementConfig={{
                                               tabIndex: 8
                                           }}
                                    /> : null}
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.createUserHandler}
                                    className={"btn"}
                                    id={"btn-save"}
                                    style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                    <i className="fas fa-save"> Save</i>
                                </button>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default CrateUserModal



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/UsersGrid/components/createUserModal/CreateUserModal.tsx